import React from 'react';
import { Star } from 'lucide-react';

interface StarRatingProps {
  rating: number;
  maxRating?: number;
  size?: number;
  showValue?: boolean;
  className?: string;
}

export const StarRating: React.FC<StarRatingProps> = ({
  rating,
  maxRating = 5,
  size = 20,
  showValue = false,
  className = '',
}) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = maxRating - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <div className="flex items-center">
        {[...Array(fullStars)].map((_, index) => (
          <Star
            key={`full-${index}`}
            size={size}
            className="fill-amber-400 text-amber-400"
          />
        ))}
        {hasHalfStar && (
          <div className="relative">
            <Star
              size={size}
              className="text-amber-400"
            />
            <div className="absolute inset-0 overflow-hidden" style={{ width: '50%' }}>
              <Star
                size={size}
                className="fill-amber-400 text-amber-400"
              />
            </div>
          </div>
        )}
        {[...Array(emptyStars)].map((_, index) => (
          <Star
            key={`empty-${index}`}
            size={size}
            className="text-gray-300"
          />
        ))}
      </div>
      {showValue && (
        <span className="text-sm text-gray-600 ml-1">
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
};
